import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
    pegnordEur: [],
    isGetPegnordEurLoading: false,
    chf: [],
    isGetChfLoading: false,
    setPegnordPriceProfile: [],
    isGetSetPriceProfileLoading: false,
    isCreatePriceProfileLoading: false,
    isBuySetPriceProfileLoading: false,
    isDeletePriceProfileLoading: false,
    minMaxDisplayEur: [],
    minMaxDisplayChf: [],
    isGetMinMaxDisplayLoading: false,
    trailingStopForDisplayEur: [],
    trailingStopForDisplayChf: [],
    isGetTrailingStopLoading: false,
    minMaxOrders: [],
    disableTrading: {},
    isGetMinMaxOrdersLoading: false,
    isBuyLoading: false,
    isSavetoWatchlistLoading: false,
    isSaveTrailingStop: false,
    isSetDisableTradingLoading: false,
    isGetDisableTradingLoading: false,
    ncgDataPoints: [],
    isGetNcgDataPointsLoading: false,
    analysisSignal: [],
    isGetAnalysisSignalLoading: false
};

export const apiGetPegnordEur = createAsyncThunk(
    'pegnord/getEur',
    async (_, thunkAPI) => {
        try {
            const response = await axios.get('/api/set/getpegnorddata');
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiGetPegnordChf = createAsyncThunk(
    'pegnord/getPegnordChf',
    async (product = 'PEG', thunkAPI) => {
        try {
            const response = await axios.get(
                `/api/set/getpegnorddata/chf?product=${product}`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiGetPegnordSetPriceProfile = createAsyncThunk(
    'pegnord/getSetPriceProfile',
    async (product = 'PEG', thunkAPI) => {
        try {
            const response = await axios.get(
                `/api/set/getpriceprofile?product=${product}`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiSavePegnordPriceProfile = createAsyncThunk(
    'pegnord/savePriceProfile',
    async (data, thunkAPI) => {
        try {
            const response = await axios.post(
                `/api/set/savepriceprofile`,
                data
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiBuyPegnordSetPriceProfile = createAsyncThunk(
    'pegnord/buySetPriceProfile',
    async ({ data, product = 'PEG' }, thunkAPI) => {
        try {
            const response = await axios.post(
                `/api/set/buypriceprofile?product=${product}`,
                data
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiDeletePegnordProfile = createAsyncThunk(
    'pegnord/deletePriceProfile',
    async ({ data, product = 'PEG' }, thunkAPI) => {
        try {
            const response = await axios.post(
                `/api/set/deletepriceprofile?product=${product}`,
                data
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiGetPegnordMinMaxDisplay = createAsyncThunk(
    'pegnord/getMinMaxDisplay',
    async ({ product, currency }, thunkAPI) => {
        try {
            const response = await axios.get(
                `/api/set/getMinMaxForDisplay?product=${product}&currency=${currency}`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiGetPegnordTrailingStopForDisplay = createAsyncThunk(
    'pegnord/getTrailingStop',
    async ({ product, currency }, thunkAPI) => {
        try {
            const response = await axios.get(
                `/api/set/getTrailingStopForDisplay?product=${product}&currency=${currency}`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiGetPegnordMinMaxOrders = createAsyncThunk(
    'pegnord/getMinMaxOrders',
    async (_, thunkAPI) => {
        try {
            const response = await axios.get(`/api/set/getMinMaxOrders`);
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiBuyPegnordContract = createAsyncThunk(
    'pegnord/buyPegnordContract',
    async (data, thunkAPI) => {
        try {
            const response = await axios.post('/api/saveorder', data);
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiBuyPegnordContractMinMax = createAsyncThunk(
    'pegnord/buyPegnordContractMinMax',
    async (data, thunkAPI) => {
        try {
            const response = await axios.post('/api/saveMinMaxOrder', data);
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiSavePegnordTrailingStop = createAsyncThunk(
    'pegnord/saveTrailingStop',
    async (data, thunkAPI) => {
        try {
            const response = await axios.post(
                '/api/set/saveTrailingStop',
                data
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

// set disable trading
export const apiSetPegnordDisableTrading = createAsyncThunk(
    'pegnord/setDisableTrading',
    async (disableTrading, thunkAPI) => {
        try {
            const response = await axios.post(
                `/api/disable_trading?disable=${disableTrading.disable}`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

// get disable trading
export const apiGetPegnordDisableTrading = createAsyncThunk(
    'pegnord/getDisableTrading',
    async (_, thunkAPI) => {
        try {
            const response = await axios.get(`/api/disable_trading`);
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiGetPegnordNcgDataPoints = createAsyncThunk(
    'pegnord/getNcgDataPoints',
    async ({ sym, currency }, thunkAPI) => {
        try {
            const response = await axios.get(
                `/api/get_ncg_data_points?sym=${sym}&currency=${currency}`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiGetPegnordAnalysisSignal = createAsyncThunk(
    'pegnord/getAnalysisSignal',
    async ({ sym, product }, thunkAPI) => {
        try {
            const response = await axios.get(
                `/api/get_analysis_signals?symbol=${sym}&product=${product}`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiSaveToWatchlistPegnord = createAsyncThunk(
    'pegnord/saveToWatchlist',
    async ({ symbol, product, currency }, thunkAPI) => {
        try {
            const response = await axios.post(
                `/api/save_to_watchlist?symbol=${symbol}&product=${product}&currency=${
                    currency || ''
                }`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

const pegnordSlice = createSlice({
    name: 'pegnord',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(apiGetPegnordEur.pending, (state) => {
                state.isGetPegnordEurLoading = true;
            })
            .addCase(apiGetPegnordEur.fulfilled, (state, action) => {
                state.isGetPegnordEurLoading = false;
                state.pegnordEur = action.payload.data;
            })
            .addCase(apiGetPegnordEur.rejected, (state) => {
                state.isGetPegnordEurLoading = false;
            });

        // Get PEGNORD CHF
        builder
            .addCase(apiGetPegnordChf.pending, (state) => {
                state.isGetChfLoading = true;
            })
            .addCase(apiGetPegnordChf.fulfilled, (state, action) => {
                state.chf = action.payload.data;
                state.isGetChfLoading = false;
            })
            .addCase(apiGetPegnordChf.rejected, (state) => {
                state.isGetChfLoading = false;
            });

        // Get Set Priceprofile
        builder
            .addCase(apiGetPegnordSetPriceProfile.pending, (state) => {
                state.isGetSetPriceProfileLoading = true;
            })
            .addCase(
                apiGetPegnordSetPriceProfile.fulfilled,
                (state, action) => {
                    state.isGetSetPriceProfileLoading = false;
                    state.setPegnordPriceProfile = action.payload.data;
                }
            )
            .addCase(apiGetPegnordSetPriceProfile.rejected, (state) => {
                state.isGetSetPriceProfileLoading = false;
            });

        // Save Price Profile
        builder
            .addCase(apiSavePegnordPriceProfile.pending, (state) => {
                state.isCreatePriceProfileLoading = true;
            })
            .addCase(apiSavePegnordPriceProfile.fulfilled, (state) => {
                state.isCreatePriceProfileLoading = false;
            })
            .addCase(apiSavePegnordPriceProfile.rejected, (state) => {
                state.isCreatePriceProfileLoading = false;
            });

        // Buy Price Profile
        builder
            .addCase(apiBuyPegnordSetPriceProfile.pending, (state) => {
                state.isBuySetPriceProfileLoading = true;
            })
            .addCase(apiBuyPegnordSetPriceProfile.fulfilled, (state) => {
                state.isBuySetPriceProfileLoading = false;
            })
            .addCase(apiBuyPegnordSetPriceProfile.rejected, (state) => {
                state.isBuySetPriceProfileLoading = false;
            });

        // Delete Price Profile
        builder
            .addCase(apiDeletePegnordProfile.pending, (state) => {
                state.isDeletePriceProfileLoading = true;
            })
            .addCase(apiDeletePegnordProfile.fulfilled, (state) => {
                state.isDeletePriceProfileLoading = false;
            })
            .addCase(apiDeletePegnordProfile.rejected, (state) => {
                state.isDeletePriceProfileLoading = false;
            });

        // Get Min Max Display
        builder
            .addCase(apiGetPegnordMinMaxDisplay.pending, (state) => {
                state.isGetMinMaxDisplayLoading = true;
            })
            .addCase(apiGetPegnordMinMaxDisplay.fulfilled, (state, action) => {
                state.isGetMinMaxDisplayLoading = false;
                const currency = action.meta.arg?.currency;
                if (currency === 'CHF') {
                    state.minMaxDisplayChf = action.payload.data;
                } else {
                    state.minMaxDisplayEur = action.payload.data;
                }
            })
            .addCase(apiGetPegnordMinMaxDisplay.rejected, (state) => {
                state.isGetMinMaxDisplayLoading = false;
            });

        // Get Trailing Stop
        builder
            .addCase(apiGetPegnordTrailingStopForDisplay.pending, (state) => {
                state.isGetTrailingStopLoading = true;
            })
            .addCase(
                apiGetPegnordTrailingStopForDisplay.fulfilled,
                (state, action) => {
                    state.isGetTrailingStopLoading = false;
                    const currency = action.meta.arg?.currency;
                    if (currency === 'CHF') {
                        state.trailingStopForDisplayChf = action.payload.data;
                    } else {
                        state.trailingStopForDisplayEur = action.payload.data;
                    }
                }
            )
            .addCase(apiGetPegnordTrailingStopForDisplay.rejected, (state) => {
                state.isGetTrailingStopLoading = false;
            });

        // Get Min Max Orders
        builder
            .addCase(apiGetPegnordMinMaxOrders.pending, (state) => {
                state.isGetMinMaxOrdersLoading = true;
            })
            .addCase(apiGetPegnordMinMaxOrders.fulfilled, (state, action) => {
                state.isGetMinMaxOrdersLoading = false;
                state.minMaxOrders = action.payload.data;
            })
            .addCase(apiGetPegnordMinMaxOrders.rejected, (state) => {
                state.isGetMinMaxOrdersLoading = false;
            });

        // Buy Contract
        builder
            .addCase(apiBuyPegnordContract.pending, (state) => {
                state.isBuyLoading = true;
            })
            .addCase(apiBuyPegnordContract.fulfilled, (state) => {
                state.isBuyLoading = false;
            })
            .addCase(apiBuyPegnordContract.rejected, (state) => {
                state.isBuyLoading = false;
            });

        // Buy Contract Min Max
        builder
            .addCase(apiBuyPegnordContractMinMax.pending, (state) => {
                state.isBuyLoading = true;
            })
            .addCase(apiBuyPegnordContractMinMax.fulfilled, (state) => {
                state.isBuyLoading = false;
            })
            .addCase(apiBuyPegnordContractMinMax.rejected, (state) => {
                state.isBuyLoading = false;
            });

        // save trailing stop
        builder
            .addCase(apiSavePegnordTrailingStop.pending, (state) => {
                state.isSaveTrailingStop = true;
            })
            .addCase(apiSavePegnordTrailingStop.fulfilled, (state) => {
                state.isSaveTrailingStop = false;
            })
            .addCase(apiSavePegnordTrailingStop.rejected, (state) => {
                state.isSaveTrailingStop = false;
            });

        // set disable trading
        builder
            .addCase(apiSetPegnordDisableTrading.pending, (state) => {
                state.isSetDisableTradingLoading = true;
            })
            .addCase(apiSetPegnordDisableTrading.fulfilled, (state) => {
                state.isSetDisableTradingLoading = false;
            })
            .addCase(apiSetPegnordDisableTrading.rejected, (state) => {
                state.isSetDisableTradingLoading = false;
            });

        // get disable trading
        builder
            .addCase(apiGetPegnordDisableTrading.pending, (state) => {
                state.isGetDisableTradingLoading = true;
            })
            .addCase(apiGetPegnordDisableTrading.fulfilled, (state, action) => {
                state.isGetDisableTradingLoading = false;
                state.disableTrading = action.payload.data;
            })
            .addCase(apiGetPegnordDisableTrading.rejected, (state) => {
                state.isGetDisableTradingLoading = false;
            });

        // get ncg data points
        builder
            .addCase(apiGetPegnordNcgDataPoints.pending, (state) => {
                state.isGetNcgDataPointsLoading = true;
            })
            .addCase(apiGetPegnordNcgDataPoints.fulfilled, (state, action) => {
                state.isGetNcgDataPointsLoading = false;
                state.ncgDataPoints = action.payload.data;
            })
            .addCase(apiGetPegnordNcgDataPoints.rejected, (state) => {
                state.isGetNcgDataPointsLoading = false;
            });

        // get analysis signal
        builder
            .addCase(apiGetPegnordAnalysisSignal.pending, (state) => {
                state.isGetAnalysisSignalLoading = true;
            })
            .addCase(apiGetPegnordAnalysisSignal.fulfilled, (state, action) => {
                state.isGetAnalysisSignalLoading = false;
                state.analysisSignal = action.payload.data;
            })
            .addCase(apiGetPegnordAnalysisSignal.rejected, (state) => {
                state.isGetAnalysisSignalLoading = false;
            });

        // save to watchlist
        builder
            .addCase(apiSaveToWatchlistPegnord.pending, (state) => {
                state.isSavetoWatchlistLoading = true;
            })
            .addCase(apiSaveToWatchlistPegnord.fulfilled, (state) => {
                state.isSavetoWatchlistLoading = false;
            })
            .addCase(apiSaveToWatchlistPegnord.rejected, (state) => {
                state.isSavetoWatchlistLoading = false;
            });
    }
});

export default pegnordSlice.reducer;
